export const ANONYMOUS_USER = 'ANONYMOUS';

export enum FEATURE_FLAGS {
  ALEGEUS_HSA_ENABLED = 'alegeus-hsa-enabled',
  ALEGEUS_MIGRATED_CUSTOMER = 'alegeus_migrated_customer',
  CLIENT_HOME_FEED_PAGE = 'client_home_feed_page',
  CEI_reimbursement_temp_fix = 'CEI_reimbursement_temp_fix',
  ELIGIBILITY_GUIDANCE_LOREM = 'eligibility-guidance-lorem',
  ELIGIBILITY_GUIDANCE_SEARCH = 'eligibility-guidance-search',
  ENABLE_ADJUDICATION_STATUS = 'enable_adjudication_status',
  EXPIRING_FUNDS_BANNER_V2 = 'expiring-funds-banner-v-2',
  EXPIRING_FUNDS_TILE_BANNER = 'expiring-funds-tile-banners',
  FORMA_CARD_BANNER = 'forma-card-banner',
  FORMA_PRETAX_ACCOUNTS_CLAIMS_PAGE = 'pretax_2.0_mx_accounts_and_claims_page',
  GYM_SUBSCRIPTION_REFRESH = 'gym-subscription-refresh',
  HIDE_ALEGEUS_NEW_CARD_REQUEST = 'hide-alegeus-new-card-request',
  HOME_OFFICE_CATEGORY = 'home-office-category',
  HSA_INVESTMENTS = 'hsa-investments',
  MISO_PRODUCT_RECOMMENDATIONS = 'miso-product-recommendations',
  UNIT_OR_STRIPE = 'unit-or-stripe-member-direct-deposit',
  PRETAX_EXPERIMENT_TOGGLE = 'pretax_experiment_toggle',
  PRETAX_FSALPA_UNLIMITED_ROLLOVER = 'pretax-unlimited-rollover',
  PRODUCT_VARIANTS = 'product-variants',
  RUNOUT_BALANCE = 'members_page_runout_balance',
  SMART_LOOK = 'smartlook',
  STORE_LANDING_PAGE = 'store-landing-page',
  STRIPE_CARD_DISABLED = 'stripe-card-disabled',
  UNIT_FORMA_CARD = 'unit-forma-card',
  USER_CAN_DELETE_CREDIT_CARDS = 'UsersCanDeleteCreditCards',
}

export const EXPIRING_FUNDS_EVENT_MAP: {
  [key: string]: string;
} = Object.freeze({
  amount: 'expiring funds - fund amount',
  control: 'expiring funds - control',
  time: 'expiring funds - text only',
  off: 'expiring funds - off',
});

export const EXPIRING_FUNDS_EVENT_MAP_V2: {
  [key: string]: string;
} = Object.freeze({
  control: 'expiring funds text only, no account banners - control',
  'control, account banners': 'expiring funds text only - account banners',
  'amount, no account banners': 'expiring funds amount - no account banners',
  'amount, account banners': 'expiring funds amount - account banners',
  off: 'expiring funds test 2 - off',
});

export const ELIGIBILITY_GUIDANCE_EVENT_MAP = Object.freeze({
  experiment: 'Eligibility Drawer Experiment',
  control: 'Eligibility Drawer Experiment Control',
});

export const EXPIRING_FUNDS_ON_SEGMENTS = ['amount', 'time'];

export const EXPIRING_FUNDS_ON_CONTROL_BANNER_SEGMENTS = [
  'control',
  'control, account banners',
  'amount, no account banners',
  'amount, account banners',
];
export const EXPIRING_FUNDS_ACCOUNT_BANNER_SEGMENTS = [
  'control, account banners',
  'amount, account banners',
];
